import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * @graph-node {Page}
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business ルートパスから/overviewへの自動リダイレクト
 * @graph-connects none
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/overview' }) as unknown as Error;
  },
});
